import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutAlignTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutAlignTop"><Path d="M20.5 20.5V21H21V20.5H20.5ZM20.5 3.5H21V3H20.5V3.5ZM3.5 3.5V3H3V3.5H3.5ZM3.5 20.5H3V21H3.5V20.5ZM7.5 7H7V8H7.5V7ZM16.5 8H17V7H16.5V8ZM21 20.5V3.5H20V20.5H21ZM20.5 3H3.5V4H20.5V3ZM3 3.5V20.5H4V3.5H3ZM3.5 21H20.5V20H3.5V21ZM7.5 8H16.5V7H7.5V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutAlignTop;
